import React, { useEffect, useState } from 'react'
import Wrapper from '../helpers/Wrapper'
import shopImage from '../assets/images/bg_deco.webp'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'
import AccordionTwo from '../components/Accordion/AccordionTwo'
import { motion, AnimatePresence } from 'framer-motion'
import { TbFilter } from 'react-icons/tb'
import { IoCloseOutline } from 'react-icons/io5'
import { FourColumn, ThreeColumn, TwoColumn } from '../helpers/icons'
import Product from '../components/Product/Product'
import AnimatePage from '../components/AnimatePage'
import { useUtilities } from '../hooks/useUtilities'
import toast from 'react-hot-toast'
import { apiClient, baseURL } from '../helpers/Axios'
import CategoryMinifFlter from '../components/shop/CategoryMinifFlter'
import { ChangePageTitle } from '../helpers/ChangeTitle'
import MiniSort from '../components/shop/MiniSort'
import Input from '../components/Form Elements/Input'
import ReactPaginate from 'react-paginate'
import { MdOutlineReportGmailerrorred } from 'react-icons/md'


function ProductCategory() {

    // Category-name
    const { category } = useParams()

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();

    // Change the page title
    ChangePageTitle(category?.toUpperCase())

    const { data: utilities } = useUtilities();
    const [products, setProducts] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [filterOpen, setFilterOpen] = useState(false);
    const [sortBy, setSortBy] = useState(false);
    const [gridLayout, setGridLayout] = useState('grid-cols-3')
    const [values, setValues] = useState({ min_price: 0, max_price: 0 });
    const location = useLocation();


    // Fetch for products function============================================================

    useEffect(() => {
        setValues({ ...values, max_price: utilities?.maxPriceProduct?.base_price })
    },
        // eslint-disable-next-line
        [utilities?.maxPriceProduct]
    )


    useEffect(() => {
        async function fetchProducts() {
            setIsLoading(true)
            try {
                const res = await apiClient(`${baseURL}/client/utility/collections/product-category/${category}${location.search}`);
                if (res) {
                    setIsLoading(false)
                    setProducts(res.data || {})
                }
            } catch (error) {
                setIsLoading(false)
                toast.dismiss()
                toast.error(error?.response?.data || error?.message)
            }
        }
        fetchProducts();

    },
        [location.search, category]
    )



    // Paginate React

    const pageNumberChange = ({ selected }) => {
        searchParams.set("page", selected + 1)
        setSearchParams(searchParams)
    }

    // Handle Price Filter 

    const priceFilter = () => {
        if (!values.max_price) {
            return
        }
        searchParams.set("min_price", values.min_price)
        searchParams.set("max_price", values.max_price)
        setSearchParams(searchParams)
    }



    return (
        <AnimatePage>
            <div className='w-full relative'>

                {/* Loading */}
                <AnimatePresence>
                    {isLoading && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className="fixed top-0 bg-white/50 w-full h-full z-[99999]"
                        />
                    )
                    }
                </AnimatePresence>

                {/* Mobile Sortby */}
                <AnimatePresence>
                    {sortBy && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className='fixed w-full h-full z-[9999999] top-0 left-0 overflow-hidden'
                        >

                            {/* Overlay */}
                            <div
                                className="bg-black/30 absolute w-full h-full top-0 left-0 z-50 cursor-pointer"
                                onClick={() => setSortBy(false)}
                            />

                            {/* Main */}
                            <motion.div
                                initial={{ y: 400 }}
                                animate={{ y: 0 }}
                                exit={{ y: 400 }}
                                transition={{ duration: 0.2 }}
                                className="w-full bg-white fixed bottom-0 left-0
                                  z-50 overflow-y-auto"
                            >
                                <div className="flex items-center justify-between p-4 border-b mb-3">
                                    <p className="text-sm font-medium uppercase">Sort By</p>
                                    <button onClick={() => setSortBy(false)}>
                                        <IoCloseOutline size={25} />
                                    </button>
                                </div>

                                <MiniSort onCLick={() => setSortBy(false)} />
                            </motion.div>

                        </motion.div>
                    )}

                </AnimatePresence>

                {/* Mobile Filter */}
                <AnimatePresence>
                    {filterOpen && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className='fixed w-full h-full z-[9999999] top-0 left-0 overflow-hidden'
                        >

                            {/* Overlay */}
                            <div
                                className="bg-black/30 absolute w-full h-full top-0 left-0 z-50 cursor-pointer"
                                onClick={() => setFilterOpen(false)}
                            />

                            {/* Main */}
                            <motion.div
                                initial={{ x: -400 }}
                                animate={{ x: 0 }}
                                exit={{ x: -400 }}
                                transition={{ duration: 0.2 }}
                                className="w-full bg-white fixed h-full top-0 left-0 max-w-[300px] 
                                  z-50 overflow-y-auto"
                            >
                                <div className="flex items-center justify-between p-6 border-b mb-3">
                                    <p className="text-lg font-medium">Filter</p>
                                    <button onClick={() => setFilterOpen(false)}>
                                        <IoCloseOutline size={25} />
                                    </button>
                                </div>

                                <CategoryMinifFlter utilities={utilities} onCLick={() => setFilterOpen(false)} />
                            </motion.div>



                        </motion.div>
                    )}

                </AnimatePresence>

                {/* ===================================================================================================== */}

                {/* Cover Head */}
                <div className="w-full relative max-h-[200px] overflow-hidden">
                    {/* Image */}
                    <div className="relative w-full pt-[40%] xl:pt-[15%]">
                        <img src={shopImage} alt="" className='w-full h-full absolute top-0 right-0 bottom-0 left-0 object-cover' />
                    </div>

                    <div className="absolute top-0 left-0 flex items-center justify-center h-full z-50 w-full">
                        <Wrapper>
                            <h1 className='text-5xl text-white text-center capitalize'>{category}</h1>
                            <div className="flex items-center gap-3 mt-2 text-white justify-center capitalize">
                                <Link to="/">Home</Link> /
                                <Link to="">{category}</Link>
                            </div>
                        </Wrapper>
                    </div>
                </div>

                {/* Mian */}
                <div className="w-full mt-8">
                    <Wrapper>
                        <div className="w-full relative flex flex-col gap-8 lg:flex-row">

                            {/* Sidebar */}
                            {/* Sidebar */}
                            <div className="hidden lg:flex lg:w-3/12 flex-col gap-3">
                                {/* Category */}
                                <AccordionTwo title="Category" open>
                                    {utilities && utilities?.categories && utilities?.categories?.length > 0 && (
                                        <ul className="w-full mt-2 flex flex-col gap-3">
                                            {utilities?.categories?.map((category, i) => (
                                                <Link key={i} to={`/product-category/${category?.name?.toLowerCase()}`} className='text-gray-500'>{category?.name}</Link>
                                            ))}
                                        </ul>
                                    )}
                                </AccordionTwo>

                                {/* Price */}
                                <AccordionTwo title="Price" open>
                                    <div className="w-full">
                                        <div className='py-5 flex gap-2 items-center'>
                                            <div className='space-y-1'>
                                                <p className='font-medium'>From:</p>
                                                <Input no_rounded style={{ padding: "10px 8px" }} value={values.min_price}
                                                    type='number'
                                                    onChange={(e) => {
                                                        setValues({ ...values, min_price: e.target.value })
                                                    }}
                                                />
                                            </div>
                                            <div className='space-y-1'>
                                                <p className='font-medium'>To:</p>
                                                <Input no_rounded style={{ padding: "10px 8px" }}
                                                    value={values.max_price}
                                                    type='number'
                                                    onChange={(e) => {
                                                        setValues({ ...values, max_price: e.target.value })
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Filter btn */}
                                        <button
                                            className='text-sm bg-black p-2 px-3 rounded-lg text-white'
                                            onClick={priceFilter}
                                        >
                                            Apply Filter
                                        </button>
                                    </div>
                                </AccordionTwo>



                            </div>

                            {/* Main and Products */}
                            <div className="w-full lg:w-9/12 xl:p-4">

                                {/* Head */}
                                <div className="flex justify-between items-center w-full">
                                    {/* Filter and other */}
                                    <div className="flex items-center gap-1.5">
                                        {/* filter and sortby button */}
                                        <button
                                            className='bg-black uppercase rounded tracking-wide xl:hidden
                                         text-white flex items-center px-4 py-1.5 text-sm gap-1'
                                            onClick={() => setFilterOpen(!filterOpen)}
                                        >
                                            <TbFilter size={16} />
                                            Filter
                                        </button>

                                        <button
                                            className='bg-[#ebebeb] uppercase rounded tracking-wide lg:hidden
                                                 font-medium flex items-center px-4 py-1.5 text-xs gap-1'
                                            onClick={() => setSortBy(!sortBy)}
                                        >
                                            <TbFilter size={16} />
                                            Sort by
                                        </button>

                                        {/* No of results */}
                                        <div className="hidden lg:block">
                                            <p className="text-gray-600">There are {products?.products?.length} results in total</p>
                                        </div>
                                    </div>

                                    {/* Views Colums */}
                                    <div className="flex items-center gap-2">
                                        <button
                                            className={`p-1  ${gridLayout === 'grid-cols-2' ? 'text-black' : 'text-gray-400'}`}
                                            onClick={() => setGridLayout('grid-cols-2')}
                                        >
                                            <TwoColumn />
                                        </button>
                                        <button
                                            className={`p-1  ${gridLayout === 'grid-cols-3' ? 'text-black' : 'text-gray-400'} hidden lg:block`}
                                            onClick={() => setGridLayout('grid-cols-3')}
                                        >
                                            <ThreeColumn />
                                        </button>
                                        <button
                                            className={`p-1  ${gridLayout === 'grid-cols-4' ? 'text-black' : 'text-gray-400'} hidden lg:block`}
                                            onClick={() => setGridLayout('grid-cols-4')}
                                        >
                                            <FourColumn />
                                        </button>
                                    </div>

                                    {/* Sort By */}
                                    <div className="hidden md:flex items-center">
                                        <p>Sort by:</p>
                                        <select
                                            className='font-medium px-1'
                                            value={searchParams.get("sort_by") ? searchParams.get("sort_by") : ""}
                                            onChange={(e) => {
                                                searchParams.set("sort_by", e.target.value)
                                                setSearchParams(searchParams)
                                            }}
                                        >
                                            <option value="title-ascending">Alphabetically, A-Z</option>
                                            <option value="title-descending">Alphabetically, Z-A</option>
                                            <option value="price-ascending">Price, low to high</option>
                                            <option value="price-descending">Price, high to low</option>
                                            <option value="created-ascending">Date, old to new</option>
                                            <option value="created-descending">Date, new to old</option>
                                        </select>
                                    </div>
                                </div>



                                {/* ====================================================== Products =============================================== */}

                                <div className="w-full">

                                    {/* Products */}
                                    {/* Products */}
                                    {products && products?.products?.length > 0 && (
                                        <div className={`grid grid-cols-2 lg:${gridLayout} mt-8 gap-3 sm:gap-8 transition-all`}>
                                            {
                                                products?.products?.map((product, i) => (
                                                    <div key={i}>
                                                        <Product data={product} loading={false} />
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    )
                                    }



                                    {products && products?.products?.length < 1 && (
                                        <div className="mt-8">
                                            <div className="bg-[#faf0de] p-5 max-w-64 text-yellow-700 border border-yellow-500 rounded-lg">
                                                <MdOutlineReportGmailerrorred />
                                                <p className="text-[clamp(1rem,2vw+0.9rem,1.1rem]">
                                                    No products found
                                                </p>
                                            </div>
                                        </div>
                                    )}



                                    {products?.totalPages > 1 && (
                                        <div className="mt-8 flex w-full justify-center">
                                            <ReactPaginate
                                                previousLabel={false}
                                                nextLabel={false}
                                                breakLabel="..."
                                                pageCount={Number(products?.totalPages)}
                                                pageRangeDisplayed={3}
                                                marginPagesDisplayed={1}
                                                onPageChange={pageNumberChange}
                                                containerClassName={'flex items-center gap-3 mx-5 relative justify-center'}
                                                pageClassName={`border size-12 flex items-center justify-center rounded-full 
                                                hover:border-black transition`}
                                                activeClassName={'border-black'}
                                                previousLinkClassName={'previous-link'}
                                                nextLinkClassName={'next-link'}
                                            />

                                        </div>
                                    )}
                                </div>

                            </div>

                        </div>
                    </Wrapper >
                </div >
            </div >
        </AnimatePage>
    )
}

export default ProductCategory

